export class InHubMessage {
    id: string | null;
    titles: Message;
    messages: Message;
    linkText: Message;
    externalUrl: string | null;
    dismissible: boolean;
    bu: "uk" | "se";
    displayRoute: string;
    created:Date;
    createdBy: string;
  
  
    constructor(id: string | null, titles: Message, messages: Message, linkText: Message, externalUrl: string | null, dismissible: boolean, bu: "se" |  "uk", displayRoute: string, created:Date, createdBy: string) {
      this.id = id;
      this.titles = titles;
      this.messages = messages;
      this.linkText = linkText;
      this.externalUrl = externalUrl;
      this.dismissible = dismissible;
      this.bu = bu;
      this.displayRoute = displayRoute;
      this.created = created;
      this.createdBy = createdBy;
    }
  }
  

type Message = {
  en_GB?: string;
  sv_SE?: string;
}


